import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { RawHtmlInterface } from 'common/types/entities/RawHtmlInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createRawHtml(
  parentId: string,
  masterBlockId?: MasterBlockId,
): RawHtmlInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.RawHtml, parentId, masterBlockId),
    type: EntityTypeEnum.RawHtml,
    textAlign: 'center',
    html: '<h2>systeme.io</h2>',
  }
}
